module.exports = __webpack_public_path__ + "img/posterBGI.8eff4edd.png";